/**
 * @owner @Appboy/growth-engineering
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import type { ChecklistScope, ChecklistType, MilestoneChecklistApiResponse } from "./types";

export const getMilestoneChecklist = reactQueryFetcherAdapter(
  "/milestone_checklist",
  async (
    signal,
    { scope, type }: { scope?: ChecklistScope; type?: ChecklistType }
  ): Promise<MilestoneChecklistApiResponse | null> => {
    return await fetch("/milestone_checklist", "GET", { scope, type }, { signal });
  }
);
